import { merge } from 'lodash';

import NotificationStore from '@/stores/Notifications';
import LayoutStore from '@/stores/Layout';
import HotelStore from '@/stores/Hotel';
import EnumsStore from '@/stores/Enums';
import SaveStore from '@/stores/Save';

const store = merge(
  {},
  {
    modules: {
      layout: LayoutStore,
      hotel: HotelStore,
      enums: EnumsStore,
      notifications: NotificationStore,
      save: SaveStore,
    },
    getters: {
      layout: state => state.layout,
      hotel: state => state.hotel,
      enums: state => state.enums,
      notifications: state => state.notifications,
      save: state => state.save,
    },
  },
);

export default store;



// WEBPACK FOOTER //
// ./src/lib/util/store.js